module.exports = __webpack_public_path__ + "img/5.2157dde8.jpg";